module.exports = __webpack_public_path__ + "img/btpn-logo-tepat.616cc3fe.png";